// src/data/categoriesData.js
const categoriesData = [
  {
    id: 1,
    name: "Services",
    items: [
      // { title: "All Packages & Pricing", href: "/from-services/all" },
      { title: "I-90", subtitle: "Application to Replace Permanent Resident Card", href: "/from-services/i-90" },
      { title: "I-129F", subtitle: "Petition for Alien Fiancé", href: "/from-services/i-129f" },
      { title: "I-130", subtitle: "Petition for Alien Relative", href: "/from-services/i-130" },
      { title: "I-131", subtitle: "Application for Travel Document", href: "/from-services/i-131" },
      { title: "I-485", subtitle: "Adjustment of Status Application", href: "/from-services/i-485" },
      { title: "I-751", subtitle: "Remove Conditions on Residence", href: "/from-services/i-751" },
      { title: "I-765", subtitle: "Application for Employment Authorization", href: "/from-services/i-765" },
      { title: "I-821D", subtitle: "DACA Application Package", href: "/from-services/i-821d" },
      { title: "I-864", subtitle: "Affidavit of Support", href: "/from-services/i-864" },
      { title: "N-400", subtitle: "Application for Naturalization", href: "/from-services/n-400" },
      { title: "N-565", subtitle: "Application to Replace Citizenship Document", href: "/from-services/n-565" },
    ]
  },
  {
    id: 2,
    name: "Citizenship",
    items: [
      { title: "Citizenship through Naturalization", href: "/citizenship/citizenship-naturalization" },
      { title: "Citizenship Through Parents", href: "/citizenship/citizenship-parents" },
      { title: "Apply For Citizenship (N-400)", href: "/citizenship/n-400" },
      { title: "Apply for Certificate of Citizenship (N-600)", href: "/citizenship/n-600" },
      { title: "Replace Citizenship Document (N-565)", href: "/citizenship/n-565" },
    ]
  },
  {
    id: 3,
    name: "Green Card",
    items: [
      { title: "Apply for a Green Card", href: "/green-card/apply-green-card" },
      { title: "Green Card Renewal", href: "/green-card/green-card-renewal" },
      { title: "Green Card Replacement", href: "/green-card/green-card-replacement" },
      { title: "Renew or Replace Green Card (I-90)", href: "/green-card/i-90" },
      { title: "Remove Conditions on Green Card (I-751)", href: "/green-card/i-751" },
    ]
  },
  {
    id: 4,
    name: "Adjustment of Status",
    items: [
      { title: "Green Card through Adjustment of Status", href: "/adjustment-of-status/adjustment-status" },
      { title: "Adjustment of Status Application (I-485)", href: "/adjustment-of-status/i-485" },
      { title: "Affidavit of Support (I-864)", href: "/adjustment-of-status/i-864" },
      { title: "Employment Authorization (I-765)", href: "/adjustment-of-status/i-765" },
      { title: "Advance Parole Application (I-131)", href: "/adjustment-of-status/i-131" },
      { title: "Adjustment of Status Fee", href: "/adjustment-of-status/adjustment-fee" },
    ]
  }
];

export default categoriesData;